import {
  InnmaxCluster,
  InnmaxMarker,
  InnternalInnmaxMapV2,
  ParkingLotCluster,
} from './components'
import InnmaxFilterControl from './components/InnmaxFilterControl'
import InnmaxLayerControl from './components/InnmaxLayerControl'
import InnmaxPlaceSearchControl from './components/InnmaxPlaceSearchControl'
import InnmaxZoomControl from './components/InnmaxZoomControl'

type IInnternalInnmaxMap2 = typeof InnternalInnmaxMapV2 & {
  Marker: typeof InnmaxMarker
  Cluster: typeof InnmaxCluster
  ParkingLotCluster: typeof ParkingLotCluster
  LayerControl: typeof InnmaxLayerControl
  FilterControl: typeof InnmaxFilterControl
  PlaceSearchControl: typeof InnmaxPlaceSearchControl
  ZoomControl: typeof InnmaxZoomControl
}

const InnmaxMap2: IInnternalInnmaxMap2 =
  InnternalInnmaxMapV2 as IInnternalInnmaxMap2

InnmaxMap2.Marker = InnmaxMarker
InnmaxMap2.Cluster = InnmaxCluster
InnmaxMap2.LayerControl = InnmaxLayerControl
InnmaxMap2.FilterControl = InnmaxFilterControl
InnmaxMap2.PlaceSearchControl = InnmaxPlaceSearchControl
InnmaxMap2.ZoomControl = InnmaxZoomControl
InnmaxMap2.ParkingLotCluster = ParkingLotCluster

export default InnmaxMap2

export * from './components'
export * from './hooks'
export * from './tools'
